import {
  POINTS_FETCH
} from '../constants/ActionTypes';

const initialState = [];
export default (state = initialState, action) => {
  switch (action.type) {
    case POINTS_FETCH:
      return action.points;
    default:
      return state;
  }
};
